/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-18 15:44:02
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-19 11:20:25
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/LineCollapse/Components/LineHeader/index.tsx
 */
import React from 'react';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.less';
const LineHeader = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { header, open, hideStatusText } = props;
  return (
    <div className={css.container}>
      <div className={css.headerText}>{header}</div>
      <div className={css.middleLine} />
      {!hideStatusText && (
        <div className={css.statusText}>
          {open ? getI18n('general.hide') : getI18n('general.show')}
        </div>
      )}
    </div>
  );
};
export default LineHeader;
